import { axios } from '@Root/API'

export const getAll = (studyProgrammeId, params) => {
	return axios.get(`program/${studyProgrammeId}/curriculum-accreditation`, { params })
}
